/**
 * 微课奖励相关接口
 * 接口文档https://note.youdao.com/ynoteshare1/index.html?id=90f3f4ec657ea9285f01a4c71802b970&type=note
 * 原型https://oqygx5stj9.feishu.cn/docs/doccncm5XSM8oGGp2BKtpBEhnve
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const microClassAward = {
	// 微课_奖励设置
	setRewardSetting(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.cloudEducation}/taiEducation/v1/reward_setting`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 微课_获取奖励设置列表
	getRewardSetting(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.cloudEducation}/taiEducation/v1/reward_setting`,
			headers: config.headers,
			params
		});
	},
	// 微课_奖励明细列表
	getrewardList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.cloudEducation}/taiEducation/v1/reward_list`,
			headers: config.headers,
			params
		});
	}
};

export default microClassAward;
